import moment from 'moment-timezone';
import Moment = moment.Moment;
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { BaseAvatar } from './base/avatar';
import { SimpleOrganization } from '../../services/organization/organization.service';

export class AssignedSalesRep extends BaseAvatar {
    id: number;
    email: string;
    phone: string;
    meetingLink: string;
    secondaryMeetingLink: string;

    lastLead: Moment;
    excludeFromLeads: boolean;
    weight: number;
    skipStart: Moment;
    skipEnd: Moment;
    lastSkipped: Moment;
    organizations: SimpleOrganization[];
    organizationsCount: number;

    constructor(data: any) {
        super(data);

        if (data.id) {
            this.id = data.id;
        }

        const timezone = LegFiJwtService.getTimezone();
        this.email = data.email || data.user?.email || 'onboarding@payhoa.com';

        // avatar already sets name, unless it's null
        if (data.user && data.user.memberships) {
            const membership = data.user.memberships[0];
            this.name = membership.profile.givenNames + (membership.profile.familyName ? ' ' + membership.profile.familyName : '');
        }
        this.name = this.name ?? 'Support';

        this.meetingLink = data.meetingLink || 'https://meetings.hubspot.com/payhoa/45-minute-launchpad-demo';
        this.secondaryMeetingLink = data.secondaryMeetingLink || 'https://meetings.hubspot.com/payhoa/30-minute-launchpad-round-robin';

        if (data.phone) {
            this.phone = data.phone;
        }

        if (data.lastLead) {
            this.lastLead = moment.utc(data.lastLead, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (data.hasOwnProperty('excludeFromLeads')) {
            this.excludeFromLeads = data.excludeFromLeads;
        }

        if (data.weight) {
            this.weight = 1 / data.weight;
        }

        if (data.skipStart) {
            this.skipStart = moment.utc(data.skipStart, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (data.skipEnd) {
            this.skipEnd = moment.utc(data.skipEnd, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (data.lastSkipped) {
            this.lastSkipped = moment.utc(data.lastSkipped, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (data.organizations) {
            this.organizations = data.organizations.map((org: Object) => new SimpleOrganization(org));
        }

        if (data.organizationsCount) {
            this.organizationsCount = data.organizationsCount;
        }
    }

    get description() {
        return this.name !== 'Support' ? 'Dedicated Onboarding Specialist' : 'PayHOA Onboarding Team';
    }
}
